import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AuthForm, PasswordForgotForm, PasswordResetForm, AuthUser, PasswordChangeForm } from './auth.model';
import { AuthStore, AuthState } from './auth.store';

import { environment } from '@environments/environment';


@Injectable({ providedIn: 'root' })
export class AuthService {

  protected baseUrl= `${environment.server}/${environment.client}`
  constructor(private authStore: AuthStore, private http: HttpClient) {
  }

  login( cred: AuthForm ) {

    return this.http.post<AuthState>( this.baseUrl + '/auth/login',  cred).pipe(tap( user  => {
        this.authStore.login(user);
    }));
  }

  logout() {
		this.authStore.logout();
  }

  passwordForgot( form: PasswordForgotForm ) {
    return this.http.post(this.baseUrl + '/auth/password-forgot', form );
  }
  
  passwordChange( form: PasswordChangeForm ) {
    return this.http.post(this.baseUrl + '/auth/password-change', form );
  }

  passwordReset( form: PasswordResetForm ) {
    return this.http.post(this.baseUrl + '/auth/password-reset', form );
  }
  
  updateUser( profile: Partial<AuthUser>) {
    
    return this.http.patch<AuthUser>(this.baseUrl + '/auth/profile', profile ).pipe(tap( user  => {
      this.authStore.updateProfile( user );
    }));
  }

}
